import React from "react";
import { Col, Row } from "reactstrap";
import { Container } from "src/components/Container/Container";
import SingleSelectField from "src/components/Form/SingleSelectFieldV2/SingleSelectField";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import { addDefaultOption } from "src/util/utils.defaultValues";
import * as S from "../../../constants/StringConstants";
import { CARRIER_OPTIONS, COLUMNS } from "../Constants/columns";

type Props = {
  values: any | null;
};

export const Import: React.FC<Props> = props => {
  const { values } = props;

  const carrierOptions = addDefaultOption("", CARRIER_OPTIONS);
  const carrierAlphabeticallyOptions = carrierOptions.sort((a, b) => a.key.localeCompare(b.key));

  const columnOptions = addDefaultOption(
    "", // we can have any label here if no column is selected
    values.columnNames.map((name, i) => ({ key: name, value: i })),
  );

  return (
    <Container padding="2rem">
      <h1 className="form-title mb-4">{S.CAMP_DETAIL_TITLE}</h1>

      <Row>
        <TextField key="fileName" name="fileName" label={S.CS_CAMPAIGN_NAME} />
      </Row>
      <Row>
        <SingleSelectField label={S.CS_CARRIER_LABEL} name="options.carrierId" options={carrierAlphabeticallyOptions} />
      </Row>

      <Row className="my-3">
        <h1 className="form-title">{S.CS_COLUMN_MAPPING}</h1>
      </Row>

      {COLUMNS.map(({ label, key, isMandatory }, index) => (
        <Row key={key}>
          <Col>
            <SingleSelectField
              label={label}
              isRequired={isMandatory}
              name={`mapTo.[${index}].value`}
              options={columnOptions}
              validate={value => {
                if (isMandatory && (!value || value === "" || value <= 0)) {
                  return "Required";
                }
              }}
            />
          </Col>
        </Row>
      ))}
    </Container>
  );
};
